import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxC0MenuMessagesScheme = z.object({
  warehouse_title: themeScheme.MessageScheme.default("HURTOWNIA"),
  warehouse_subtitle: themeScheme.MessageScheme.default("Szukaj"),
  offers_title: themeScheme.MessageScheme.default("OFERTA"),
  offers_subtitle: themeScheme.MessageScheme.default("Wyceniaj"),
  cart_title: themeScheme.MessageScheme.default("KOSZYK"),
  cart_subtitle: themeScheme.MessageScheme.default("Kompletuj"),
  orders_and_deliveries_title: themeScheme.MessageScheme.default(
    "ZAMÓWIENIA I DOSTAWY"
  ),
  orders_and_deliveries_subtitle: themeScheme.MessageScheme.default("Odbieraj"),
  shopping_for_company_title:
    themeScheme.MessageScheme.default("ZAKUPY NA FIRMĘ"),
  shopping_for_company_subtitle:
    themeScheme.MessageScheme.default("Sprzedaż bieżąca"),
  choose_another_warehouse: themeScheme.MessageScheme.default(
    "WYBIERZ INNĄ INWESTYCJĘ"
  ),
  investments_street_shortcut: themeScheme.MessageScheme.default("Ul."),
  atests_title: themeScheme.MessageScheme.default("Atesty"),
  raports_title: themeScheme.MessageScheme.default("Raporty"),
  deposits_title: themeScheme.MessageScheme.default("Depozyty"),
  returns_title: themeScheme.MessageScheme.default("Zwroty"),
  complains_title: themeScheme.MessageScheme.default("Reklamacje"),
  documents_title: themeScheme.MessageScheme.default("Dokumenty"),

  plus_icon_text: themeScheme.MessageScheme.default("Więcej"),
  minus_icon_text: themeScheme.MessageScheme.default("Mniej"),
});

export const IBoxC0MenuSettingsScheme = z.object({
  offers_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  cart_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  orders_and_deliveries_redirect_url:
    themeScheme.UrlScheme.default("").catch(""),
  orders_and_deliveries_redirect_url_for_visitors:
    themeScheme.UrlScheme.default("").catch(""),
  documents_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  atests_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  raports_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  deposits_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  returns_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  complains_redirect_url: themeScheme.UrlScheme.default("").catch(""),
  popup_choose_another_warehouse_id: themeScheme.RowPopupScheme.default(""),
});
